import { z } from 'zod';

/**
 * Zod response schema — Analytics hub (pilot migrasi TanStack Query).
 * Validasi runtime + tipe statis untuk respons `/api/admin/analytics/*`.
 * Bentuk mengikuti kontrak yang dipakai komponen (OverviewTab, dst).
 * Ditambah inkremental per-endpoint (ADR-002).
 */

const analyticsEventRow = z.object({
  event_date: z.string(),
  event_name: z.string(),
  count: z.number(),
  unique_users: z.number(),
});

export const OverviewResp = z.object({
  dau: z.number(),
  wau: z.number(),
  mau: z.number(),
  signups_period: z.number(),
  revenue_period: z.number(),
  paid_orders_period: z.number(),
  trend: z.array(analyticsEventRow),
  today: z.array(analyticsEventRow),
});
export type OverviewResp = z.infer<typeof OverviewResp>;

const memberHealthEntry = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  plan_name: z.string(),
  active_days_30: z.number(),
  last_active: z.string().nullable(),
  current_streak: z.number(),
});

export const MemberHealthResp = z.object({
  total_paid_members: z.number(),
  counts: z.object({
    active: z.number(),
    at_risk: z.number(),
    dormant: z.number(),
  }),
  active: z.array(memberHealthEntry),
  at_risk: z.array(memberHealthEntry),
  dormant: z.array(memberHealthEntry),
});
export type MemberHealthResp = z.infer<typeof MemberHealthResp>;
